module.exports = __webpack_public_path__ + "img/761-5a1e5d.png";